import { useMemo } from "react";

const NOT_APPLICABLE = "NOT_APPLICABLE";

const ProductionStatusLabel = ({ order }) => {
  const {
    artworkStatus,
    directToGarmentStatus,
    embroideryStatus,
    highDefinitionDigitalStatus,
    screenPrintingStatus,
    shippingStatus,
    transfersGlitterStatus,
    transfersStandardStatus,
    transfersUvStatus,
    vinylStatus
  } = order;

  const status = useMemo(() => {
    return {
      isBlank:
        directToGarmentStatus === NOT_APPLICABLE &&
        embroideryStatus === NOT_APPLICABLE &&
        screenPrintingStatus === NOT_APPLICABLE &&
        vinylStatus === NOT_APPLICABLE &&
        highDefinitionDigitalStatus === NOT_APPLICABLE &&
        transfersStandardStatus === NOT_APPLICABLE &&
        transfersGlitterStatus === NOT_APPLICABLE &&
        transfersUvStatus === NOT_APPLICABLE,
      isProductionReady: artworkStatus === "APPROVED",
      isScreenPrintingInProgress: screenPrintingStatus === "IN_PROGRESS",
      isEmbroideryInProgress: embroideryStatus === "IN_PROGRESS",
      isDTGInProgress: directToGarmentStatus === "IN_PROGRESS",
      isHighDefinitionDigitalInProgress:
        highDefinitionDigitalStatus === "IN_PROGRESS",
      isTransfersStandardInProgress:
        transfersStandardStatus !== "READY" &&
        transfersStandardStatus !== "COMPLETE",
      isTransfersGlitterInProgress:
        transfersGlitterStatus !== "READY" &&
        transfersGlitterStatus !== "COMPLETE",
      isTransfersUVInProgress:
        transfersUvStatus !== "READY" && transfersUvStatus !== "COMPLETE",
      needsEmbroidery:
        embroideryStatus !== NOT_APPLICABLE && embroideryStatus !== "COMPLETE",
      needsScreenPrinting:
        screenPrintingStatus !== NOT_APPLICABLE &&
        screenPrintingStatus !== "COMPLETE",
      needsDTG:
        directToGarmentStatus !== NOT_APPLICABLE &&
        directToGarmentStatus !== "COMPLETE",
      needsHighDefinitionDigital:
        highDefinitionDigitalStatus !== NOT_APPLICABLE &&
        highDefinitionDigitalStatus !== "COMPLETE",
      needsTransfersStandard:
        transfersStandardStatus !== NOT_APPLICABLE &&
        transfersStandardStatus !== "COMPLETE",
      needsTransfersGlitter:
        transfersGlitterStatus !== NOT_APPLICABLE &&
        transfersGlitterStatus !== "COMPLETE",
      needsTransfersUV:
        transfersUvStatus !== NOT_APPLICABLE &&
        transfersUvStatus !== "COMPLETE",
      needsVinyl: vinylStatus !== NOT_APPLICABLE && vinylStatus !== "COMPLETE",
      isShipped: shippingStatus === "SHIPPED",
      isPartiallyShipped: shippingStatus === "PARTIALLY_SHIPPED",
      isReadyToShip:
        (directToGarmentStatus === NOT_APPLICABLE ||
          directToGarmentStatus === "COMPLETE") &&
        (embroideryStatus === NOT_APPLICABLE ||
          embroideryStatus === "COMPLETE") &&
        (screenPrintingStatus === NOT_APPLICABLE ||
          screenPrintingStatus === "COMPLETE") &&
        (vinylStatus === NOT_APPLICABLE || vinylStatus === "COMPLETE")
    };
  }, [
    artworkStatus,
    directToGarmentStatus,
    embroideryStatus,
    highDefinitionDigitalStatus,
    screenPrintingStatus,
    shippingStatus,
    transfersGlitterStatus,
    transfersStandardStatus,
    transfersUvStatus,
    vinylStatus
  ]);

  if (status.isBlank) {
    return "Blank Shirts";
  } else if (!status.isProductionReady) {
    return "Not Ready for Production";
  } else if (status.isScreenPrintingInProgress) {
    return "Screen Printing In Progress";
  } else if (status.isEmbroideryInProgress) {
    return "Embroidery In Progress";
  } else if (status.isDTGInProgress) {
    return "DTG In Progress";
  } else if (status.isHighDefinitionDigitalInProgress) {
    return "HDD In Progress";
  } else if (status.isTransfersStandardInProgress) {
    return "Transfers - Standard In Progress";
  } else if (status.isTransfersGlitterInProgress) {
    return "Transfers - Glitter In Progress";
  } else if (status.isTransfersUVInProgress) {
    return "Transfers - UV In Progress";
  } else if (status.needsEmbroidery) {
    return "Needs Embroidery";
  } else if (status.needsScreenPrinting) {
    return "Needs Screen Printing";
  } else if (status.needsDTG) {
    return "Needs DTG";
  } else if (status.needsHighDefinitionDigital) {
    return "Needs HDD";
  } else if (status.needsTranfersStandard) {
    return "Needs Transfers - Standard";
  } else if (status.needsTranfersGlitter) {
    return "Needs Transfers - Glitter";
  } else if (status.needsTranfersUV) {
    return "Needs Transfers - UV";
  } else if (status.needsVinyl) {
    return "Needs Vinyl";
  } else if (status.isShipped) {
    return "Shipped";
  } else if (status.isPartiallyShipped) {
    return "Partially Shipped";
  } else if (status.isReadyToShip) {
    return "Ready To Ship";
  }
  return "Undefined";
};

export default ProductionStatusLabel;
